import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { addCookie } from '../../../../browser/utils/js-cookie';
import { CountrysideBuildersBanner } from './CountrysideBuildersBanner';
import { trackScrollOnBanner } from './tracking';

export const CountrysideBuildersBannerContainer = () => {
  const handleBannerViewed = React.useCallback(() => {
    trackScrollOnBanner();
  }, []);
  /* istanbul ignore next */
  React.useEffect(() => {
    addCookie('buildersBannerShown', 'true');
  }, []);

  return (
    <ActionAfterViewed callback={handleBannerViewed}>
      <CountrysideBuildersBanner />
    </ActionAfterViewed>
  );
};

CountrysideBuildersBannerContainer.displayName = 'CountrysideBuildersBannerContainer';
